import { Injectable } from '@angular/core';
import { windowFactory } from '../window/window.factory';

@Injectable()
export class WindowRefService {
  get nativeWindow(): Window {
    return windowFactory();
  }
}
